import { useApi } from '@api/ApiProvider'
import { useI18n } from '@i18n/I18nProvider'
import { useQuery } from '@tanstack/react-query'

export const treeQueryKey = (code: string, locale: string) => ['tree', code.toUpperCase(), locale] as const

export const useTree = (code: string) => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: treeQueryKey(code, locale), queryFn: () => api.tree(code, locale) })
}
